var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"RealisationProcessStatus"},[_c('h4',{staticClass:"pb-1"},[_vm._v(" Status van realisatieprocessen ")]),_c('GChart',{staticStyle:{"transform":"scale(0.9,0.9) translateY(-3em)"},attrs:{"type":"BarChart","data":_vm.chartDataTable,"options":_vm.chartOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }